import React, { Fragment } from "react";
import {
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
  subheader: {
    paddingBottom: theme.spacing(3),
    "& > h6": {
      paddingBottom: theme.spacing(1.25)
    }
  },
  listItem: {
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      padding: 0
    }
  },
  divider: {
    marginLeft: theme.spacing(8),
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(6)
    }
  }
}));

const Outline = ({ sections }) => {
  const classes = useStyles();
  return (
    <>
      {sections.map((section, index) => (
        <List
          key={section.title + index}
          aria-label="contacts"
          classes={{ subheader: classes.subheader }}
          subheader={<Typography variant="h6">{section.title}</Typography>}
        >
          {section.items.map((item, index) => (
            <Fragment key={index}>
              <ListItem className={classes.listItem} key={item.title + index}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText
                  primary={item.title}
                  primaryTypographyProps={{
                    variant: "subtitle1",
                    color: "textSecondary"
                  }}
                />
              </ListItem>

              <Divider
                variant="inset"
                component="li"
                classes={{ inset: classes.divider }}
              />
            </Fragment>
          ))}
        </List>
      ))}
    </>
  );
};

Outline.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          icon: PropTypes.node,
          title: PropTypes.string
        })
      )
    })
  )
};

export default Outline;
